import React from "react";
import { Field, reduxForm } from "redux-form";
import validator from 'validator';
import {renderTextField} from "../helpers/formFields";

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from "@mui/material/Typography";

class AccountForm extends React.Component {

    onSubmit = (formValues) => {
        this.props.onSubmit(formValues);
    }

    render() {
        return (
            <form onSubmit={this.props.handleSubmit(this.onSubmit)}>
                <Grid container spacing={2}>
                <Grid item xs={12}>
                        <Field
                            name="email"
                            id="email"
                            component={renderTextField}
                            label="Email Address"
                            autoComplete="email"
                            // autoFocus
                            margin="normal"
                            required
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Field
                            name="firstname"
                            id="firstname"
                            component={renderTextField}
                            label="First Name"
                            // autoFocus
                            margin="normal"
                            required
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Field
                            name="lastname"
                            id="lastname"
                            component={renderTextField}
                            label="Last Name"
                            // autoFocus
                            margin="normal"
                            required
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Field
                            name="password"
                            id="password"
                            component={renderTextField}
                            label="Password"
                            type="password"
                            autoComplete="password"
                            // autoFocus
                            margin="normal"
                            required
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                        />
                        <Typography variant="body2" display="block" color="text.secondary" gutterBottom>
                            Minimum 8 characters, with uppercase, lowercase, number and a symbol
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Field
                            name="password_confirm"
                            id="password_confirm"
                            component={renderTextField}
                            label="Confirm Password"
                            type="password"
                            // autoFocus
                            margin="normal"
                            required
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                </Grid>
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                >
                    Next
                </Button>
            </form>
        )
    }
}

const validate = (formValues) => {
    const errors = {};

    if (!formValues.email) {
        errors.email = 'You must enter a email';    
    }

    if (formValues.email) {
        if (!validator.isEmail(formValues.email)) {
            errors.email = 'You must enter a valid email';    
        }
    }

    if (!formValues.password) {
        errors.password = 'You did not enter a password';
    }

    if (formValues.password) {
        if (!validator.isStrongPassword(formValues.password, {
            minLength: 8,
            minUppercase: 1,
            minLowercase: 1,
            minNumbers: 1,
            minSymbols: 1,
          })) {
            errors.password = 'Password is not strong enough'
        }
    }

    if (formValues.password_confirm) {
        if (formValues.password !== formValues.password_confirm) {
            errors.password_confirm = 'You must enter the same password';
        }
    }

    return errors;
};

export default reduxForm({
    form: 'accountForm',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    enableReinitialize : true,
    validate: validate
})(AccountForm);